<script>
  import { cart } from "../models/cart.js";
  import { puzzlePack } from "../models/puzzlePack.js";

  export let product;
  export let eventID;
  export let compact = false;

  let added = false;
  $: isInCart = $cart.some((c) => c.id === product.id);
  $: hasTicket = $cart.find((c) => c.product_type.name === "Ticket");

  async function addItem(product) {
    if (eventID) product.event_id = eventID;
    cart.add(product);
    added = $cart.some((c) => c.id === product.id);

    if (added) {
      setTimeout(() => {
        added = false;
      }, 2500);
    }
  }
</script>

{#if added}
  <p class="cart-success">
    <svg class="icon">
      <use href="/icons.svg#check" />
    </svg>
    Added to Cart!
  </p>
{:else if isInCart}
  {#if hasTicket && hasTicket.event_id !== eventID && product.product_type.name == "Ticket"}
    <button class="btn" class:btn-plain={compact} disabled>
      <svg class="icon">
        <use href={"/icons.svg#cart"} />
      </svg>
      Add to cart
    </button>
    <p>
      <b>You already have one event ticket in your cart. Limit 1 per order.</b>
    </p>
  {:else}
    <div class="cart-item-quantity">
      {#if product.product_type.id === 2 || product.product_type.id === 3}
        <button
          class="btn btn-link cart-btn"
          on:click|stopPropagation={cart.remove(product)}
        >
          <svg class="icon">
            <use href="/icons.svg#minus" />
          </svg>
        </button>
        <span class="cart-item-quantity-value">
          Qty: {$cart.reduce(
            (a, p) => a + (p.id == product.id ? p.quantity : 0),
            0
          )}
        </span>
        <button
          class="btn btn-link cart-btn"
          on:click|stopPropagation={cart.add(product)}
        >
          <svg class="icon">
            <use href="/icons.svg#plus" />
          </svg>
        </button>
      {:else}
        <button
          class="btn btn-expanded"
          class:btn-plain={compact}
          on:click={cart.remove(product)}
        >
          <svg class="icon">
            <use href={"/icons.svg#clear"} />
          </svg>
          Remove from Cart
        </button>
      {/if}
    </div>
  {/if}
{:else if !puzzlePack.isInit() && product.product_type.id === 1 && compact}
  <button
    class="btn"
    class:btn-plain={compact}
    on:click={(window.location.href = `/product/${product.title}/sku/${product.sku}`)}
    disabled={product.in_stock <= 0 ||
      (cart.hasMembershipInCart() && product.product_type.id === 1) ||
      !product.active}
  >
    {#if product.in_stock <= 0 || product.active === false}
      Out of Stock
    {:else}View Rental Options{/if}
  </button>
{:else}
  <button
    class="btn"
    class:btn-plain={compact}
    on:click={() => addItem(product)}
    disabled={(product.in_stock <= 0 &&
      product.product_type.name !== "Ticket") ||
      (cart.hasMembershipInCart() && product.product_type.id === 1) ||
      !product.active ||
      ($cart.some((p) => p.product_type.name === "Ticket") &&
        product.product_type.name === "Ticket" &&
        eventID !== product.event_id)}
  >
    <svg class="icon">
      <use href={"/icons.svg#cart"} />
    </svg>

    {#if product.product_type.name !== "Ticket" && (product.in_stock <= 0 || product.active === false)}
      Out of Stock
    {:else if product.product_type.id === 1}
      Rent with Puzzle Pack
    {:else}Add to Cart{/if}
  </button>
  {#if hasTicket && product.product_type.name == "Ticket"}
    <p>
      <b>You already have one event ticket in your cart. Limit 1 per order.</b>
    </p>
  {/if}
{/if}

<style>
  .cart-item-quantity {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .cart-btn {
    padding: 0 var(--spacing-sm);
  }
  .cart-btn .icon {
  }
  .cart-success {
    color: var(--col-success);
    padding: 0 var(--spacing-sm);
    margin: var(--spacing-xs) 0;
    line-height: var(--line-height);
  }
</style>
